export default "__VITE_ASSET__618281d2__"